module.exports = __webpack_public_path__ + "media/images/squash-image-30b17c0a65d526b095c1f27786d8c621.jpg";